import type { TimelineSlot } from '../weddingInfo'

/**
 * A list of times down a rule, used for both halves of the running order.
 *
 * Each slot gets one dot and one time, however many points hang off it, so
 * several things happening at once read as one moment rather than as repeated
 * entries on the clock.
 */
export function Timeline({ slots }: { slots: readonly TimelineSlot[] }) {
  return (
    <ol className="border-ink/10 mt-4 space-y-4 border-l pl-6">
      {slots.map((slot, index) => (
        <li key={`${slot.time}-${index}`} className="relative">
          {/* Centred on the slot rather than pinned near its top, so it stays
              level with the block beside it however many points it has. */}
          <span className="bg-claret absolute top-1/2 -left-[1.8rem] block h-2 w-2 -translate-y-1/2 rounded-full" />
          <p className="text-ink-soft text-xs tracking-widest uppercase">{slot.time}</p>

          <ul className="mt-0.5 space-y-2">
            {slot.points.map((point) => (
              <li key={point.title}>
                <p>{point.title}</p>
                {point.detail && <p className="text-ink-soft mt-0.5 text-sm">{point.detail}</p>}
              </li>
            ))}
          </ul>
        </li>
      ))}
    </ol>
  )
}
